import { Injectable, ViewChild } from '@angular/core';

@Injectable({
  providedIn: 'root'
}) 

export class AlertService {
  
  alerts:any;
  alertStatus:number;
  agentFilter:string;
  agentId: number;
  alertTypeFilter:string;
  alertZones:any;
  zoneFilter: string;
  outZoneFilter: string;
  lateFilter: string;
  zoneId: number;
  statusFilter:string;
  statusToDisplay:string;
  selectedOrder:string;
  filtersApplied:string[];
  alertTypes:any;
  alertTypeDisabled:boolean;
  agents:any;
  totalLength: number;
  page: number;
  canceledDate: Date;
  
  constructor() {}
}
